import { render, staticRenderFns } from "./OrderTimeline.vue?vue&type=template&id=6a79a98f"
import script from "./OrderTimeline.vue?vue&type=script&lang=js"
export * from "./OrderTimeline.vue?vue&type=script&lang=js"
import style0 from "./OrderTimeline.vue?vue&type=style&index=0&id=6a79a98f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/locales2/share/orderTimeline.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fusr%2Fsrc%2Fapp%2Fsrc%2Fcomponents%2Frecord_detail_v2%2Forder_status%2FOrderTimeline.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports